"use strict";

// Bitwise functions
//
// The color representation would ideally be 32-bits unsigned, but JS bitwise
// operators only work as 32-bits signed. The range of Smi values on V8 is also
// 32-bits signed. Those two factors make it that it's much more efficient to just
// use signed integers to represent the data.
//
// Colors with a R channel >= 0x80 will be a negative number, but that's not really
// an issue at any point because the bits for signed and unsigned integers are always
// the same, only their interpretation changes.
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cast = cast;
exports.get = get;
exports.set = set;
const INT32_TO_UINT32_OFFSET = 2 ** 32;
function cast(n) {
  if (n < 0) {
    return n + INT32_TO_UINT32_OFFSET;
  }
  return n;
}
function get(n, offset) {
  return n >> offset & 0xff;
}
function set(n, offset, byte) {
  return n ^ (n ^ byte << offset) & 0xff << offset;
}
